import type { IconData } from '@stacksjs/iconify-core'

export const healthDrugMedicine: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 5.34h1.53v7.61h-1.53Zm-1.52 7.61h1.52v1.53h-1.52Zm0-9.14h1.52v1.53h-1.52Zm-1.52 10.67h1.52V16h-1.52Zm0-12.19h1.52v1.52h-1.52ZM25.14 16h1.53v1.53h-1.53Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.52H22.1ZM19.05.76h7.62v1.53h-7.62ZM2.29 28.19h1.52v1.53h1.52v1.52h7.62v-1.52h1.53v-1.53H16v-1.52h1.52v-1.52h1.53v-1.53h1.52V22.1h1.53v-1.53h-1.53v-1.52h-1.52v-1.52h-1.53V16H16v-1.52h-1.52v-1.53h-1.53v-1.52h-1.52V9.91H9.9v1.52H8.38v1.52H6.86v1.53H5.33V16H3.81v1.53H2.29v1.52H.76v7.62h1.53Zm6.09-1.52h3.05v-1.52h1.52v-1.53h1.53V22.1H16v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.52H8.38Zm9.14-24.38h1.53v1.52h-1.53ZM16 3.81h1.52v1.53H16Zm-1.52 1.53H16v1.52h-1.52Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default healthDrugMedicine
